import PropTypes from 'prop-types';
import React from 'react';

import Alert from 'Components/Alert';
import SvgIcon from 'Components/Base/Icon';
import Text from 'Components/Base/Text';
import Snackbar from 'Components/Snackbar';

import EggSpaceOnboarding from '../../Components/EggSpaceOnboarding';

export default function EggSpaceOnboardingContainer({
  open,
  onClose,
  onEnroll,
  loading,
  error,
  subtitle,
}) {
  return (
    <>
      <EggSpaceOnboarding
        open={open}
        onClose={onClose}
        onEnroll={onEnroll}
        loading={loading}
        error={error}
        subtitle={subtitle}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={!!error}
        autoHideDuration={2000}
      >
        <Alert icon={<SvgIcon icon={SvgIcon.ICON_LIST.DANGER} size="20" color="danger" />}>
          <Text>กรุณาลองใหม่อีกครั้ง</Text>
        </Alert>
      </Snackbar>
    </>
  );
}

EggSpaceOnboardingContainer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onEnroll: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  subtitle: PropTypes.bool.isRequired,
};
